import React from 'react'
import { change as changeFieldValue, formValueSelector, reduxForm} from 'redux-form';
import {connect} from 'react-redux';
import $ from 'jquery';
import { showErrorMsg, showSuccessMsg } from '../../util/messagesUtil';
import { tamanhoArquivoUpload } from '../../util/applicationContext';
import cancelarReservasComReembolso from '../../actions/reserva/cancelarReservasComReembolso';
import selecionaReservaReembolsoSolicitado from '../../actions/reserva/selecionaReservaReembolsoSolicitado';
import anexarDocumentoReservaReembolsoSolicitado from '../../actions/reserva/anexarDocumentoReservaReembolsoSolicitado';

export class ModalAnexaDocumentoReservasParaReembolsoEfetivado extends React.Component {
  fecharModal () {
    $('#modalAnexaDocumentoReservasParaReembolsoEfetivado')
      .modal('hide');
    $('#modalAnexaDocumentoReservasParaReembolsoEfetivado')
      .hide();
    $('.modal-backdrop')
      .hide();

    this.props.selecionaReservaReembolsoSolicitado();
    this.removerArquivo();
  }

  montarParametros() {
    return { 
      empresaId: this.props.empresaSelecionada.id,              
      reservaId: this.props.reservaSelecionada.id,
      base64ComprovanteReembolso: this.props.base64ComprovanteReembolso,
      nomeComprovanteReembolso: this.props.nomeComprovanteReembolso
    }
  }

  submit () {
    if (!this.props.base64ComprovanteReembolso || !this.props.nomeComprovanteReembolso) {
      showErrorMsg('Falta anexar o comprovante');
      return;
    }

    this.props.anexarDocumentoReservaReembolsoSolicitado(this.montarParametros())
      .then(() => {
          showSuccessMsg('Documento Anexado Com Sucesso');
          this.fecharModal();
          this.props.buscarPedidos()    
      })
  }
  
  handleChange(event) {
      const file = event.target.files[0];
      if (/\.(jpe?g|png|pdf)$/i.test(file.name) === false) {
          return
      }
      if (file.size > tamanhoArquivoUpload) {
          showErrorMsg('Tamanho do arquivo excede 20 MB');
          return
      }
      this.converterParaBase64(file)
  }

  removerArquivo() {
      this.props.changeFieldValue('formularioAnexarDocumentoReservasParaReembolsoEfetivado',
          'base64ComprovanteReembolso', null);
      this.props.changeFieldValue('formularioAnexarDocumentoReservasParaReembolsoEfetivado',
          'nomeComprovanteReembolso', null);
      this.props.changeFieldValue('formularioAnexarDocumentoReservasParaReembolsoEfetivado',
          'urlComprovanteTransferencia', null);
  }

  converterParaBase64(file) {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = function () {
          this.props.changeFieldValue('formularioAnexarDocumentoReservasParaReembolsoEfetivado',
              'base64ComprovanteReembolso', reader.result);
          this.props.changeFieldValue('formularioAnexarDocumentoReservasParaReembolsoEfetivado',
              'nomeComprovanteReembolso', file.name);
      }.bind(this);
  }

  exibirReservas () {
    return <div className='mt-4 ml-2'>
      Reservas:
      <ul>
        {this.props.reservas.filter(f => f.selecionada)
          .map(reserva => <React.Fragment key={reserva.id}>
            <li>{reserva.descCidadeOrigem} -&gt; {reserva.descCidadeDestino}: {reserva.passageiroDto.nome}</li>
          </React.Fragment>)}
      </ul>
    </div>
  }

  exibirRemoverComprovante() {
    return <>
      <button type="button" className="btn btn-editar"
              title='Remover'
              onClick={() => this.removerArquivo()}>
          <i className="material-icons nav-icon" style={{
              color: 'red'
          }}>&#xe14c;</i>
      </button>	
    </>
  }

  exibirAnexar() {
    if (this.props.base64ComprovanteReembolso || this.props.urlComprovanteTransferencia) {
        return (
            <div className="row align-items-center mt-2">
                <div className='col-md-6 label-cancelamento ml-2'>
                    <strong>Comprovante:</strong>
                </div>
                <span>{this.props.nomeComprovanteReembolso}</span>
                {this.exibirRemoverComprovante()}                
            </div>)
    }

    return <>
      <div className='input-wrapper mt-3'>
          <label className='btn-laranja' htmlFor='input-file'>
              <div className='row align-items-center'>
                  <i className="material-icons aberto">&#xe2c3;</i>
                  <strong className='ml-2'>Anexar comprovante</strong>
              </div>
          </label>
          <input id='input-file' type='file' value='' accept="image/png,image/jpeg,application/pdf"
                  onChange={this.handleChange.bind(this)}/>
      </div>
      <label style={{fontSize: 'smaller'}}>
          * Tamanho máximo permitido: 20 MB
          <br/>
          * Formatos suportados: PNG, JPEG, PDF
          <br/>
          * Se desejar anexar mais de um arquivo de imagem, utilize o seguinte link para uni-los:
          <a target="_BLANK" href='https://smallpdf.com/pt/jpg-para-pdf'
              rel='noreferrer'> https://smallpdf.com/pt/jpg-para-pdf.</a>
          <br/>
          * Se desejar anexar mais de um arquivo PDF, utilize o seguinte link para uni-los:
          <a target="_BLANK" href='https://smallpdf.com/pt/juntar-pdf'
              rel='noreferrer'> https://smallpdf.com/pt/juntar-pdf.</a>
      </label>
    </>
        
  }

  render () {
    const {
      handleSubmit, submitting, invalid, pristine
    } = this.props;
    return (
      <div className="modal fade" id="modalAnexaDocumentoReservasParaReembolsoEfetivado" tabIndex="-1" role="dialog"
           aria-labelledby="modalAnexaDocumentoReservasParaReembolsoEfetivado" aria-hidden="true">
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <form onSubmit={handleSubmit(this.submit.bind(this))}>
              <div className="modal-body">                
                <h3>Número Bilhete: {this.props.reservaSelecionada.id}</h3>                
                  {this.exibirAnexar()}
              </div>
              <div className="modal-footer ">
                <button id='cancelar' type="button" className="btn btn-outline-secondary"
                        data-dismiss="modal">Não
                </button>
                <button type="submit" disabled={invalid || submitting || pristine}
                        className="btn btn-laranja">Sim
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    )
  }
}

const selector = formValueSelector('formularioAnexarDocumentoReservasParaReembolsoEfetivado');

export const mapStateToProps = state => (
  {
    initialValues: {
      base64ComprovanteReembolso: state.reservaSelecionadaReembolsoSocilitado.comprovanteReembolso,
      nomeComprovanteReembolso: state.reservaSelecionadaReembolsoSocilitado.nomeComprovanteReembolso,

    },
    reservaSelecionada: state.reservaSelecionadaReembolsoSocilitado,
    empresaSelecionada: state.empresaSelecionada,
    urlComprovanteTransferencia: selector(state, 'urlComprovanteTransferencia'),
    nomeComprovanteReembolso: selector(state, 'nomeComprovanteReembolso'),    
    base64ComprovanteReembolso: selector(state, 'base64ComprovanteReembolso'),
  });

export default connect(mapStateToProps, {  
  cancelarReservasComReembolso,
  selecionaReservaReembolsoSolicitado,
  anexarDocumentoReservaReembolsoSolicitado,
  changeFieldValue
})(reduxForm({
  form: 'formularioAnexarDocumentoReservasParaReembolsoEfetivado',
  enableReinitialize: true,
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true
})(ModalAnexaDocumentoReservasParaReembolsoEfetivado));
